import { isEmpty } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

interface Params<T> {
  onSubmit?: (value: T) => void | Promise<void>;
  defaultValue?: T;
}

const useTableSearchBox = <T extends {} = {}>(params: Params<T> = {}) => {
  const { onSubmit, defaultValue = {} } = params;
  const submitRef = useRef(onSubmit);
  const searchBox = useRef<T>(defaultValue as T);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    submitRef.current = onSubmit;
  }, [onSubmit]);

  const onChangeValue = useCallback(async (name: string, value: any) => {
    searchBox.current = {
      ...searchBox.current,
      [name]: value,
    };

    if (!submitRef.current || isEmpty(searchBox.current)) {
      return;
    }

    try {
      setSearching(true);
      await submitRef.current(searchBox.current);
    } catch (error) {
      console.error("🚀 ~ file: use-table-search-box.ts:20 ~ handleSubmit ~ error:", error);
    } finally {
      setSearching(false);
    }
  }, []);

  const getValue = useCallback(() => searchBox.current, []);

  return { onChangeValue, getValue, searching };
};

export default useTableSearchBox;
